import React, { useState } from 'react';
import { Error } from '../Error';
import { Label } from '../Label';
import { appendClassProps } from '../util';
export const Checkbox = ({ checked = false, revealErrorMessage = false, disabled = false, hideErrorSection = false, label, labelColor, errorMessage, children, tooltip, className, onChangeValue }) => {
    const [dirty, setDirty] = useState(false);
    const onChange = (event) => {
        const target = event.target;
        if (typeof onChangeValue === 'function') {
            onChangeValue(target.checked);
        }
        setDirty(true);
    };
    const showErrorMessage = errorMessage && (revealErrorMessage || dirty) ? true : false;
    return (React.createElement("div", { className: `flex flex-col${appendClassProps(className)}` },
        React.createElement("div", { className: "flex flex-row gap-2 items-center" },
            React.createElement("input", { className: `cursor-pointer text-blue-800 focus:ring-0 focus:ring-offset-0 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-blue-800 focus-visible:ring-offset-0 focus-visible:ring-offset-white${disabled ? ' bg-gray-300 cursor-not-allowed' : ''}`, type: "checkbox", "data-testid": "checkbox", onChange: onChange, checked: checked ?? false, disabled: disabled }),
            label ? (React.createElement(Label, { className: `${labelColor ? labelColor : ''}`, tooltip: tooltip, textColor: labelColor }, label)) : (children)),
        !hideErrorSection && (React.createElement(Error, { errorMessage: errorMessage, showErrorMessage: showErrorMessage }))));
};
export * from './index.types';
//# sourceMappingURL=index.js.map